import { ethers } from "ethers";
import {
  nils,
  iso,
  nano,
  tofeth,
  toeth,
  tofpval,
  blocktime_iso,
  base64_to_json,
} from "../../utils/utils.jsx";
import _ from "lodash";
import abi from "./abis/DNA_SkinsMaster.json";
import { CV2_Contract } from "./cv2_base.js";
import { contractAddress_list } from "../contracts.jsx";
import get_logs_parser from "./extra_logs_parsers.js";

class Contract extends CV2_Contract {
  constructor({ contract_k, contractAddress, aumode, abi, ...ext }) {
    super({ contract_k, contractAddress, aumode, abi, ...ext });
  }

  async getParsedLogs(logs) {
    if (!logs) return [];

    let logrows = [];
    for (let log of logs) {
      let iface = new ethers.Interface(this.abi);
      let par = iface.parseLog(log);

      if (nils(par)) continue;

      let name = par.name;
      let o = {
        name,
        logIndex: log.logIndex,
        hash: log.transactionHash,
        blockNumber: log.blockNumber,
      };
      o.id = `${o.hash}:${o.logIndex}`;

      // Note: DNA_SkinsMaster.sol doesn't have custom events defined
      // Most operations go through PayRouter which has its own events
      // If events are added later, parsing logic can be added here

      logrows.push(o);
    }

    // Parse base skin contract events and add them to results
    const base_skin_events = get_logs_parser.base_skin(logs);
    logrows = [...logrows, ...base_skin_events];

    return logrows;
  }
}

const k = "skinsmaster";

const get_contract_address = () => {
  return contractAddress_list.skinsmaster;
};

const get_contract = async (ext = {}) => {
  const contractAddress = get_contract_address();
  const runner = new Contract({
    contract_k: k,
    contractAddress,
    aumode: ext.aumode || "thirdweb",
    abi,
    ...ext,
  });
  return runner;
};

const DNA_SkinsMaster = {
  k,
  get_contract,
  get_contract_address,
};

export default DNA_SkinsMaster;
